import PortfolioNavigation from '@common/Components/PortfolioNavigation.vue';
import PortfolioScenariosCommands from '@Quest/PortfolioScenarios/Domain/commands-vue-component';
import PortfolioScenariosQueries from '@Quest/PortfolioScenarios/Domain/queries-vue-component';
import { CriteriaPageReadModel, CriterionAnalysisReadModel } from '@Quest/PortfolioScenarios/Domain/readmodels';
import Component, { mixins } from 'vue-class-component';


@Component({ components: { PortfolioNavigation } })
export default class CriteriaPage extends mixins(PortfolioScenariosQueries, PortfolioScenariosCommands)
{
    get workspaceId(): number { return Number.parseInt(this.$route.params.workspaceId); }
    get tchProjectId(): number { return Number.parseInt(this.$route.params.tchProjectId); }
    get scenarioId() { return this.$route.params.scenarioId; }

    rm: CriteriaPageReadModel | null = null;
    criteriaFilter: string = "Objectives";

    get allCriteria(): CriterionAnalysisReadModel[] { return this.rm?.Criteria ?? []; }
    get goal(): CriterionAnalysisReadModel | null { return this.allCriteria.find(c => c.IsGoal) ?? null; }

    get criteria(): CriterionAnalysisReadModel[]
    {
        const filter = this.criteriaFilter;

        if (filter === 'Objectives')
        {
            return this.criteria.filter(a => a.IsTop);
        }
        else if (filter === 'Attributes')
        {
            return this.criteria.filter(a => a.IsBottom);
        }
        else if (filter === 'All criteria')
        {
            return this.criteria.filter(a => !a.IsGoal);
        }

        return [];
    }

    mounted()
    {
        document.title = "Portfolio Plan - Criteria";
        this.runCriteriaPageQueryV1(this.workspaceId, this.tchProjectId, this.scenarioId);
    }

    onSetModel(model: any, modelName: string)
    {
        if (modelName == "CriteriaPageReadModel")
        {
            this.rm = model as CriteriaPageReadModel;
        }
    }
}